export default __webpack_public_path__ + "static/media/100_18622.6e5ebb31.jpg";